export default "__VITE_ASSET__CnKoTrjd__"